import { IGetListSaleDealParams } from 'interfaces/SaleDeal';

export const SALE_DEAL_VARIABLE = {
  getListSaleDeal: (params: IGetListSaleDealParams) => {
    const { page, pageSize, saleDeal, conditionType, status } = params;

    return {
      skip: (page - 1) * pageSize || 0,
      take: pageSize,
      input: {
        ...(status !== undefined && { status: { equals: status } }),
        ...(saleDeal && { saleDeal: { equals: saleDeal } }),
        ...(conditionType && {
          tconditionType: { id: { equals: conditionType } },
        }),
      },
    };
  },
};
